/**
 * @generated SignedSource<<cfa7e7c2a5a4d4dd9f977f5793378b7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type IssueTypeIssueType = "BUG" | "CUSTOM" | "EPIC" | "FEATURE" | "TASK" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type IssueTypesDialogIssueType$data = {
  readonly description: string | null;
  readonly id: string;
  readonly isEnabled: boolean;
  readonly issueType: IssueTypeIssueType;
  readonly name: string;
  readonly " $fragmentType": "IssueTypesDialogIssueType";
};
export type IssueTypesDialogIssueType$key = {
  readonly " $data"?: IssueTypesDialogIssueType$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypesDialogIssueType">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueTypesDialogIssueType"
};

(node as any).hash = "6c1ef6375db8c98be03e6b0c3cc8eb2b";

export default node;
